import React, { PureComponent } from 'react';
import { func, shape, string, arrayOf } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel, WithLoading } from '@widergy/energy-ui';

import { CANCELATION, REITERATION } from 'constants/userForms';
import { formResponsePropTypes } from 'redux/userFormHandlers';
import { message } from 'utils/stringUtils';

import stylesJS from './styles';
import styles from './styles.module.scss';

class FormDetails extends PureComponent {
  render() {
    return (
      <div style={stylesJS.container}>
        {this.props.formDetails.map(detail => (
          <div key={detail.name} style={stylesJS.details}>
            <UTLabel small>{detail.name}</UTLabel>
            <UTLabel small darkGray>
              {detail.value}
            </UTLabel>
          </div>
        ))}
        {this.props.form.reiterable && this.props.form.status.isPending && this.props.form.external_id && (
          <UTButton
            className={styles.actionButton}
            onPress={() =>
              this.props.handleOpenActionModal(this.props.form.id, CANCELATION, this.props.form.form_name)
            }
          >
            {message('Commons:cancel')}
          </UTButton>
        )}
        {this.props.form.cancellable && this.props.form.status.isPending && (
          <UTButton
            className={styles.actionButton}
            onPress={() =>
              this.props.handleOpenActionModal(this.props.form.id, REITERATION, this.props.form.form_name)
            }
          >
            {message('FieldDetails:reiterate')}
          </UTButton>
        )}
        <UTButton secondary onPress={this.props.onReturn} className={styles.actionButton}>
          {message('Commons:back')}
        </UTButton>
      </div>
    );
  }
}

FormDetails.propTypes = {
  handleOpenActionModal: func,
  onReturn: func.isRequired,
  form: formResponsePropTypes,
  formDetails: arrayOf(
    shape({
      name: string.isRequired,
      value: string.isRequired
    })
  )
};

export default WithLoading(props => props.loading)(Radium(FormDetails));
